import { render, staticRenderFns } from "./TaskApplicationsItem.vue?vue&type=template&id=c25419ee&scoped=true&lang=pug&"
import script from "./TaskApplicationsItem.vue?vue&type=script&lang=js&"
export * from "./TaskApplicationsItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskApplicationsItem.vue?vue&type=style&index=0&id=c25419ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25419ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
